export enum PostStatus
{
    Active,
    Inactive,
    Deleted
    
};